import BasePlayer from './BasePlayer';

/**
 * Android native player implementation
 * Delegates to native Android IPTV activity via window.android bridge
 */
class AndroidPlayer extends BasePlayer {
  constructor() {
    super();
  }

  supportsFullscreenToggle() {
    return false;
  }

  async play(url, isFullScreen = true) {
    // Android player doesn't use the standard flow
    // It's handled differently in checkDevice by launching native activity
    console.log('Android: play() called - handled by native activity launch');
  }

  async stop() {
    console.log('Android: stop() - handled by native activity');
  }

  async setDisplayRect(coords) {
    console.log('Android: setDisplayRect() - not applicable for native player');
  }

  async toggleFullscreen() {
    console.log('Android: toggleFullscreen() - not applicable for native player');
  }

  /**
   * Launch Android native IPTV activity with channel list
   * @param {Array} channelsList - List of channels to pass to native player
   */
  launchNativeActivity(channelsList) {
    if (window.android && window.android.launchIptvStreamActivity) {
      console.log('Android: launching native IPTV activity with', channelsList.length, 'channels');
      window.android.launchIptvStreamActivity(JSON.stringify(channelsList));
    } else {
      console.warn('Android: native bridge not available');
    }
  }
}

export default AndroidPlayer;

